import { createRoot } from "react-dom/client";
import CorpoSite from "./CorpoSite";

const Div_Mae = document.getElementById("Div_Para_Referencia_E_Criacao_React");
const root = createRoot(Div_Mae);

root.render(<CorpoSite />);
